<template>
  <svg class="cross-icon" :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" @click="handleClick">
    <path fill="currentColor" :class="crossClass" fill-rule="evenodd" d="m10 11.178 6.078 6.078 1.178-1.179L11.179 10l6.077-6.077-1.178-1.179L10 8.821 3.923 2.744 2.744 3.923 8.822 10l-6.078 6.077 1.179 1.179L10 11.178Z" clip-rule="evenodd" />
  </svg>
</template>

<script>
export default {
  name: 'Cross',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: [String, Number],
      default: '19px',
    },
    height: {
      type: [String, Number],
      default: '19px',
    },
  },
  computed: {
    crossClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
        'text-grey': this.color === 'grey',
        'test-red': this.color === 'red',
      };
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
  .cross-icon {
    display: block;
  }
  .test-red {
    color: red;
  }
</style>
